<template>
<gap top="single" bottom="single" right="double">
    <title-regular>Description:</title-regular>
    <text-regular>
        <slot></slot>
    </text-regular>
</gap>
</template>

<script>
export default {
    props: ['content'],
    components: {
        gap: require('./gap.vue').default,
        'title-regular': require('./title-regular.vue').default,
        'text-regular': require('./text-regular.vue').default,
    },
}
</script>
